const data = {
  title: "Floor 1-7",
  musicTrack: "MUSIC_WORLD1",
  theme: "BLUE",
  tilesWidth: 9,
  tilesHeight: 9,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 2,
      y: 8,
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 8,
      y: 2,
    },
    {
      type: "WALL",
      x: 8,
      y: 10,
    },
    {
      type: "WALL",
      x: 4,
      y: 10,
    },
    {
      type: "WALL",
      x: 4,
      y: 11,
    },
    {
      type: "WALL",
      x: 4,
      y: 9,
    },
    {
      type: "WALL",
      x: 4,
      y: 4,
    },
    {
      type: "WALL",
      x: 4,
      y: 1,
    },
    {
      type: "WALL",
      x: 6,
      y: 4,
    },
    {
      type: "WALL",
      x: 6,
      y: 7,
    },
    {
      type: "WALL",
      x: 5,
      y: 10,
    },
    {
      type: "WALL",
      x: 6,
      y: 10,
    },
    {
      type: "WALL",
      x: 9,
      y: 4,
    },
    {
      type: "WALL",
      x: 10,
      y: 4,
    },
    {
      type: "WALL",
      x: 10,
      y: 6,
    },
    {
      type: "WALL",
      x: 11,
      y: 6,
    },
    {
      type: "WALL",
      x: 10,
      y: 8,
    },
    {
      type: "WALL",
      x: 11,
      y: 10,
    },
    {
      type: "WALL",
      x: 10,
      y: 10,
    },
    {
      type: "KEY",
      x: 11,
      y: 8,
      color: "GREEN",
    },
    {
      type: "WALL",
      x: 3,
      y: 6,
    },
    {
      type: "WALL",
      x: 6,
      y: 3,
    },
    {
      type: "WALL",
      x: 7,
      y: 4,
    },
    {
      type: "WALL",
      x: 4,
      y: 6,
    },
    {
      type: "WALL",
      x: 1,
      y: 4,
    },
    {
      type: "WALL",
      x: 7,
      y: 6,
    },
    {
      type: "WALL",
      x: 6,
      y: 6,
    },
    {
      type: "WALL",
      x: 4,
      y: 3,
    },
    {
      type: "WALL",
      x: 9,
      y: 6,
    },
    {
      type: "WALL",
      x: 6,
      y: 1,
    },
    {
      type: "WALL",
      x: 6,
      y: 9,
    },
    {
      type: "WALL",
      x: 1,
      y: 6,
    },
    {
      type: "THIEF",
      x: 5,
      y: 5,
    },
    {
      type: "WALL",
      x: 4,
      y: 7,
    },
    {
      type: "WALL",
      x: 3,
      y: 4,
    },
    {
      type: "CHIP",
      x: 8,
      y: 8,
    },
    {
      type: "KEY",
      x: 7,
      y: 5,
      color: "BLUE",
    },
    {
      type: "SWITCH",
      x: 8,
      y: 5,
    },
    {
      type: "SWITCH_WALL",
      x: 2,
      y: 6,
      isRaised: true,
    },
    {
      type: "LOCK",
      x: 6,
      y: 8,
      color: "BLUE",
    },
    {
      type: "LOCK",
      x: 8,
      y: 6,
      color: "GREEN",
    },
    {
      type: "KEY",
      x: 5,
      y: 8,
      color: "GREEN",
    },
    {
      type: "SWITCH_WALL",
      x: 4,
      y: 2,
      isRaised: true,
    },
    {
      type: "SWITCH_WALL",
      x: 6,
      y: 2,
      isRaised: true,
    },
    {
      type: "SWITCH_WALL",
      x: 2,
      y: 4,
      isRaised: true,
    },
    {
      type: "SWITCH_WALL",
      x: 8,
      y: 4,
      isRaised: true,
    },
  ],
};

export default data;
